function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  inset: 0;\n  z-index: 60;\n  display: ",
        ";\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: rgba(3, 7, 18, 0.92);\n  backdrop-filter: blur(6px);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  max-width: 72rem;\n  max-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  z-index: 80;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 9999px;\n  border: none;\n  background: rgba(15, 23, 42, 0.55);\n  color: #fff;\n  cursor: pointer;\n  transition: transform 0.2s ease, background 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n    background: rgba(15, 23, 42, 0.78);\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 1.5rem;\n  left: 1.5rem;\n  z-index: 80;\n  padding: 0.35rem 0.85rem;\n  border-radius: 9999px;\n  background: rgba(15, 23, 42, 0.55);\n  color: #fff;\n  font-size: 0.875rem;\n  font-weight: 500;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  max-height: 90vh;\n  max-width: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000;\n  border-radius: 18px;\n  overflow: hidden;\n\n  video {\n    max-width: 100%;\n    max-height: 90vh;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  z-index: 75;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  background: rgba(2, 132, 199, 0.75);\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  max-width: 100%;\n  max-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    max-width: 100%;\n    max-height: 90vh;\n    object-fit: contain;\n    border-radius: 18px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  ",
        "\n  transform: translateY(-50%);\n  z-index: 75;\n  width: 46px;\n  height: 46px;\n  border-radius: 9999px;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.55);\n  color: #fff;\n  cursor: pointer;\n  transition: transform 0.2s ease, background 0.2s ease;\n\n  &:hover {\n    transform: translateY(-50%) scale(1.05);\n    background: rgba(15, 23, 42, 0.8);\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 75;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.5rem 0.9rem;\n  border-radius: 9999px;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(4px);\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  width: ",
        ";\n  height: 8px;\n  border-radius: 9999px;\n  border: none;\n  background: ",
        ";\n  cursor: pointer;\n  transition: background 0.2s ease, width 0.2s ease;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
export var ModalContainer = styled.div(_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? 'flex' : 'none';
});
export var ModalContent = styled.div(_templateObject1());
export var CloseButton = styled.button(_templateObject2());
export var MediaCounter = styled.div(_templateObject3());
export var MediaViewer = styled.div(_templateObject4());
export var VideoViewerContainer = styled.div(_templateObject5(), function(param) {
    var isShortForm = param.isShortForm;
    return isShortForm ? '24rem' : '80rem';
});
export var ShortFormIndicator = styled.div(_templateObject6());
export var ImageContainer = styled.div(_templateObject7());
export var NavButton = styled.button(_templateObject8(), function(param) {
    var direction = param.direction;
    return direction === 'left' ? 'left: 1.5rem;' : 'right: 1.5rem;';
});
export var IndicatorsContainer = styled.div(_templateObject9());
export var IndicatorsBar = styled.div(_templateObject10());
export var Indicator = styled.button(_templateObject11(), function(param) {
    var isActive = param.isActive;
    return isActive ? '12px' : '8px';
}, function(param) {
    var isActive = param.isActive;
    return isActive ? '#fff' : 'rgba(255, 255, 255, 0.55)';
});
